import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyOutcomeOverview = lazyWithRetry(() => import("./OutcomeOverview"));

const OutcomeOverview = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyOutcomeOverview {...props} />;

export default OutcomeOverview;
